import semanticColorStyles from '@design/styles/SemanticColor.module.scss';
import { TextSection } from '@terminal/components/text-section/TextSection';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './BullBearPoints.module.scss';

interface CaseAnalysisData {
  base_case: string;
  bear_case: string;
  bull_case: string;
}

interface BullBearPointsProps {
  title: string;
  data: CaseAnalysisData;
  variant?: 'primary' | 'secondary';
  useBulletPoints?: boolean;
}

export const BullBearPoints = ({
  title,
  data,
  variant = 'primary',
  useBulletPoints = true,
}: BullBearPointsProps) => {
  const { t } = useTranslation(['earnings']);

  const { bull_case, base_case, bear_case } = data;

  const cases = [
    {
      type: 'bull' as const,
      content: bull_case,
      label: t('earningsInsight.bullCase'),
    },
    {
      type: 'base' as const,
      content: base_case,
      label: t('earningsInsight.baseCase'),
    },
    {
      type: 'bear' as const,
      content: bear_case,
      label: t('earningsInsight.bearCase'),
    },
  ].filter(caseItem => caseItem.content.trim());

  if (cases.length === 0) {
    return null;
  }

  const textContent = cases.map(caseItem => (
    <React.Fragment key={caseItem.type}>
      <span
        className={clsx(styles.caseHeader, {
          [semanticColorStyles.directionPositive]: caseItem.type === 'bull',
          [semanticColorStyles.directionNegative]: caseItem.type === 'bear',
          [semanticColorStyles.directionNeutralSoft]: caseItem.type === 'base',
        })}
      >
        {caseItem.label}
      </span>
      <span>{caseItem.content}</span>
    </React.Fragment>
  ));

  return (
    <TextSection
      title={title}
      variant={variant}
      useBulletPoints={useBulletPoints}
      textContent={textContent}
    />
  );
};
